import store from '@/store'
import { find } from 'lodash'
import { accessDeniedToaster } from "@/routes/guards/abilities/pop-denied-access";

let guard = () => new Promise( (resolve, reject) => {
    return (
        find(store.getters['auth/abilities'], ability =>
        ability.name === 'view-trashed-custom-field-templates' &&
        ability.entity_type === 'App\\Models\\CustomFieldTemplate'
        )
    ) ? resolve()
        : accessDeniedToaster(reject, {
            name: 'dashboard'
        })
})

export default {
    name: 'view-trashed-custom-field-templates',
    run: guard
}